import { t } from '@lingui/core/macro'
import { useLingui } from '@lingui/react/macro'
import { extractLocale } from 'components/extractLocale'
import { usePostHog } from 'posthog-js/react'
import { useEffect, type FC } from 'react'
import { setAmplitudeUserId } from 'utils/amplitude'

import ErrorComponent from './components/ErrorComponent'
import Widget from './Widget'

const URLLayer: FC = () => {
  const { i18n } = useLingui()
  const posthog = usePostHog()

  const queryString = window.location.search
  const params = new URLSearchParams(queryString)
  const token = params.get('token')
  const customer = params.get('customer') || ''
  const customers = params.get('customers') || ''
  const adversusLeadId = params.get('adversus-lead-id') || ''
  const sessionId = params.get('sessionId')

  // oxlint-disable-next-line react/exhaustive-deps -- only run on init
  useEffect(() => {
    const organizationUid = params.get('org')
    if (organizationUid) {
      posthog?.identify(organizationUid)
      setAmplitudeUserId(organizationUid)
    }

    const language = navigator.languages.find((l) => extractLocale(l) !== null)
    const langCode = extractLocale(language)
    if (langCode) i18n.activate(langCode)
  }, [])

  return token ? (
    <Widget
      apiToken={token}
      filter={{ customer, adversusLeadId, customers }}
      sessionId={sessionId}
    />
  ) : (
    <ErrorComponent error={new Error(t`Missing api token`)} />
  )
}

export default URLLayer
